<template>

  <div class="palette-modal stretchy container" v-bind:class="{ open: state.paletteView!=null }">
    <div class="stretchy background-cover" v-on:click="state.closePalette()"></div>

    <div class="palette total-center">
      <div class="palette-border">
        <div class="palette-content">
          <component :is="state.paletteView"></component>
          <div class="palette-cover"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss">

  @import '../styles/app/colors';

  .palette-modal {

    bottom: 55px;

    display: none;
    &.open {
      display: block;
    }
  }

  .background-cover {
    background-color: rgba(0,0,0,.01);
  }

  .palette {
    background-color: #fff;
    border: 1px solid #000;
  }

  .palette-border {
    margin: 2px;
    border: 2px solid #000;
    padding: 1px;
    overflow: hidden;
  }

  .palette-content {
    position: relative;
    //outline: 1px solid red;

    .palette-cover {
      //outline: 2px dashed green;
      position: absolute;
      width: 100%;
      bottom: 0;
      background-color: #fff;
      pointer-events: none;
    }
  }

  .color {
    .palette-border {
      border-color: $color-blue;
    }
  }

</style>

<script>

  import Colors from './palettes/Colors'
  import Brushes from './palettes/Brushes'
  import LineWidths from './palettes/LineWidths'
  import OpenDialog from './palettes/OpenDialog'
  import SaveDialog from './palettes/SaveDialog'
  import Share from './palettes/Share'

  import state from '../data/state';

  export default{
    data(){
      return {
        state
      }
    },
    components: {
      Colors,
      Brushes,
      LineWidths,
      OpenDialog,
      SaveDialog,
      Share
    },
    methods: {
      onPaletteClick(e) {
        e.stopImmediatePropagation();
      },
      transitionIn() {

        TweenLite.set('.palette-border', { opacity: 0});
        TweenLite.to('.palette-border', .1, { delay: .15 + Math.random() * .15, opacity: 1.0});

        var $content = $('.palette-content > *', this.$el);
        var $cover = $('.palette-cover', this.$el);
        var h = $content.height();
        TweenLite.set($cover, { height: h, top: 0});
        TweenLite.to($cover, .789, { delay: .5 + Math.random() * .2, height: 0, top: h, ease: 'linear'});
      }
    },

    ready() {
      this.$watch('state.paletteView', ()=> {
        if(state.paletteView) {
          this.transitionIn();
        }
      })
    }
  }
</script>



// WEBPACK FOOTER //
// Palettes.vue?4aba4dc7